import React, { FC, useState } from 'react'
import Modal from '@material-ui/core/Modal'

import { CButton } from 'tabs/data/components/CButton'
import * as S from './ConfirmCloneDataset.style'

type ConfirmCloneModalProps = {
  open: boolean
  onClose: () => void
  onClone: (versionLabel: string) => Promise<void>
}

export const ConfirmCloneModal: FC<ConfirmCloneModalProps> = ({ open, onClose, onClone }) => {
  const [loading, setLoading] = useState(false)
  const [versionLabel, setVersionLabel] = useState('')

  const handleClone = async () => {
    try {
      setLoading(true)
      await onClone(versionLabel)
      onClose()
    } catch (e) {
    } finally {
      setLoading(false)
    }
  }

  if (!open) return null

  return (
    <Modal
      open={open}
      onClose={onClose}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <S.ModalWrapper>
        <S.Container>
          <S.Title>Clone Dataset</S.Title>
          <S.SubTitle>
            Creating prototype of selected dataset will be completely duplicated with the current content.
          </S.SubTitle>

          <S.InputContainer>
            <label>Version label:</label>
            <S.Input
              type="text"
              placeholder="e.g. v1.0 etc"
              value={versionLabel}
              onChange={e => setVersionLabel(e.target.value)}
              disabled={loading}
            />
          </S.InputContainer>

          <S.ButtonsWrap>
            <CButton color="secondary" label="Cancel" onClick={onClose} disabled={loading} />
            <CButton
              label="Yes, Clone"
              color="primary"
              onClick={handleClone}
              disabled={loading || !versionLabel.trim()}
            />
          </S.ButtonsWrap>
        </S.Container>
      </S.ModalWrapper>
    </Modal>
  )
}
